<template>
  <div class="ev-config-page">
    <div class="page-header">
      <div class="header-left">
        <el-button size="mini" icon="el-icon-back" @click="goBack">返回推导</el-button>
        <span class="page-title">EV 算法配置</span>
      </div>
    </div>
    <div class="page-body">
      <ev-template-vehicle-panel />
      <ev-config-panel class="config-body" />
    </div>
  </div>
</template>

<script>
import EvConfigPanel from "../components/config/EvConfigPanel";
import EvTemplateVehiclePanel from "../components/config/EvTemplateVehiclePanel";

export default {
  components: { EvConfigPanel, EvTemplateVehiclePanel },

  methods: {
    goBack() {
      this.$router.push("/work_common/ev_simulate");
    }
  }
};
</script>

<style lang="less" scoped>
.ev-config-page {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 100px);
  padding: 6px 12px 8px;
  box-sizing: border-box;
  overflow: hidden;
}

.page-header {
  flex-shrink: 0;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.page-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.config-body {
  flex: 1;
  min-height: 360px;
}
</style>
